'use client';
import * as React from 'react';
import * as RTabs from '@radix-ui/react-tabs';
import { cn } from '../cn';

export const Tabs = RTabs.Root;
export function TabsList({ className, ...props }: React.ComponentPropsWithoutRef<typeof RTabs.List>) {
  return <RTabs.List className={cn('flex items-center gap-1 hairline-b mb-4', className)} {...props} />;
}
export function TabsTrigger({ className, ...props }: React.ComponentPropsWithoutRef<typeof RTabs.Trigger>) {
  return <RTabs.Trigger className={cn('relative px-3 h-9 text-[14px] font-medium text-text-2 rounded-[var(--radius-sm)] transition-colors hover:text-text data-[state=active]:text-text outline-none focus-visible:shadow-[0_0_0_3px_var(--accent-ring)] after:absolute after:left-2 after:right-2 after:-bottom-px after:h-0.5 after:rounded-full after:bg-accent after:opacity-0 data-[state=active]:after:opacity-100 after:transition-opacity', className)} {...props} />;
}
export function TabsContent({ className, ...props }: React.ComponentPropsWithoutRef<typeof RTabs.Content>) {
  return <RTabs.Content className={cn('outline-none', className)} {...props} />;
}
